export var PRIMARY_COLOR = {
  theme: 'theme',
  danger: 'danger',
  success: 'success',
  warning: 'warning'
};